module.exports = __webpack_public_path__ + "prod/1.42.2/img/system-four.6af8c4c7.png";